import React from 'react';
import { useT } from '~app/BundleProvider';

const ArrowForwardIcon = ({ className }) => {
  const t = useT();
  return (
    <svg
      className={className}
      width="64px"
      height="138px"
      viewBox="0 0 64 138"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={t("next-page")}
    >
        <defs></defs>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-1793.000000, -1022.000000)" strokeLinecap="round">
            <g transform="translate(66.000000, 1024.000000)" stroke="#383838" strokeWidth="4">
                <g transform="translate(1729.000000, 0.500000)">
                    <path d="M0.230769231,66.9195584 L59.7692308,132.790221" transform="translate(30.000000, 99.854890) scale(1, -1) translate(-30.000000, -99.854890) "></path>
                    <path d="M0.230769231,0.20977918 L59.7692308,66.0804416"></path>
                </g>
            </g>
        </g>
    </svg>
  );
};

export default ArrowForwardIcon;



// WEBPACK FOOTER //
// ./src/components/SVG/ArrowForwardIcon.js